import { render, staticRenderFns } from "./TaxReport.vue?vue&type=template&id=7eeb5fac&"
import script from "./TaxReport.vue?vue&type=script&lang=js&"
export * from "./TaxReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eeb5fac')) {
      api.createRecord('7eeb5fac', component.options)
    } else {
      api.reload('7eeb5fac', component.options)
    }
    module.hot.accept("./TaxReport.vue?vue&type=template&id=7eeb5fac&", function () {
      api.rerender('7eeb5fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/TaxReport.vue"
export default component.exports